import { useContext } from 'react';
import { DocViewerContext, type DocViewerContextValue } from './DocViewerContext';

export function useDocViewer(): DocViewerContextValue {
  const ctx = useContext(DocViewerContext);
  if (!ctx) throw new Error('useDocViewer must be used within DocViewerProvider');
  return ctx;
}
